import { inject, Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
@Injectable({
    providedIn: 'root',
})
export class SeoService {
    private metaTag = inject(Meta);

    metaTagsBuilder(dataSource: { title?: string; description?: string }): void {
        for (const tag of <('title' | 'description')[]>['title', 'description']) {
            const content = dataSource[tag];
            if (content) {
                // Meta.updateTag upserts — creates the tag when it doesn't exist yet.
                this.metaTag.updateTag({ name: tag, content });
                this.metaTag.updateTag({ property: `og:${tag}`, content });
                this.metaTag.updateTag({ property: `twitter:${tag}`, content });
            }
        }
    }
}
